import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import PopModal from '../../../Constant/Custom/Models/PopModal';
import Loader from '../../../Constant/Custom/Loader'
import { serverUrl } from '../../../Constant/Static/config'
import './seatManipulation.css';

function SeatManipulation() {

    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [onCancel, setOnCancel] = useState(() => () => { });
    const [showCancelButton, setShowCancelButton] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [collegeCode, setCollegeCode] = useState('');
    const [branch, setBranch] = useState('');
    const [community, setCommunity] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);
    const [branches, setBranches] = useState([
        { INSTITUTION: '', BRANCH: '' }
    ]);
    const [college, setCollege] = useState({});

    const incrementSeat = async () => {
        setLoading(true);
        setShowCancelButton(false);
        try {
            const response = await axios.post(`${serverUrl}/api/admin/seat-manipulation/increment`, {
                COLL_CODE: collegeCode,
                BRANCH: branch,
                COMMUNITY: community,
                VALUE: college?.[community],
                COUNTER: college?.COUNTER,
                ALLOT_ADD: college?.ALLT_ADD
            });

            setRefreshKey(prev => prev + 1);

            if (response.status) {
                setModalType({
                    icon: 'success',
                    title: 'Seat Increment',
                    text: response.data.message
                })
                openModal();
                setOnConfirm(() => closeModal);
            }
        } catch (err) {
            setModalType({
                icon: 'error',
                title: 'Seat Increment',
                text: err.response.data.message
            })
            openModal();
            setOnConfirm(() => closeModal);
        } finally {
            setLoading(false)
        }
    };

    const decrementSeat = async () => {
        setLoading(true);
        setShowCancelButton(false);
        try {
            const response = await axios.post(`${serverUrl}/api/admin/seat-manipulation/decrement`, {
                COLL_CODE: collegeCode,
                BRANCH: branch,
                COMMUNITY: community,
                VALUE: college?.[community],
                COUNTER: college?.COUNTER,
                ALLOT_ADD: college?.ALLT_ADD
            });

            setRefreshKey(prev => prev + 1);

            if (response.status == 200) {
                setModalType({
                    icon: 'success',
                    title: 'Seat Decrement',
                    text: response.data.message
                })
                openModal();
                setOnConfirm(() => closeModal);
            }

        } catch (err) {
            setModalType({
                icon: 'error',
                title: 'Seat Decrement',
                text: err.response.data.message
            })
            openModal();
            setOnConfirm(() => closeModal);
        } finally {
            setLoading(false);
        }
    };

    const handleCollegeCodeChange = (e) => {
        setCollegeCode(e.target.value);
        setBranch('');
        setBranches([{ INSTITUTION: '', BRANCH: '' }]);
        setCollege({});
    };

    const handleRequest = async () => {
        setShowCancelButton(false);
        if (collegeCode.length == 0) {
            setModalType({
                icon: 'error',
                title: 'College Information',
                text: "kindly enter the college code..!"
            })
            openModal();
            setOnConfirm(() => closeModal);
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`${serverUrl}/api/admin/seat-manipulation/code`, { code: collegeCode });

            // console.log("Response from server", response);
            if (response.status == 200) {
                setBranches(response.data.branchList)
                setModalType({
                    icon: 'success',
                    title: 'College Information',
                    text: response.data.message
                })
                openModal();
                setOnConfirm(() => closeModal);
            }

        } catch (err) {
            // console.error('Failed to fetch college data:', err);
            setModalType({
                icon: 'error',
                title: 'College Information',
                text: err.response.message
            })
            openModal();
            setOnConfirm(() => closeModal);
        } finally {
            setLoading(false);
        }
    };

    const handleBranchChange = async (e) => {
        const selectedBranch = e.target.value;
        setBranch(selectedBranch);
        setLoading(true);
        setShowCancelButton(false);
        try {
            const response = await axios.post(`${serverUrl}/api/admin/seat-manipulation/seats`, { code: collegeCode, branch: selectedBranch });

            if (response.status) {
                setCollege(response.data.seatValues[0] || {});
                setModalType({
                    icon: 'success',
                    title: 'Seat Retrieval',
                    text: response.data.message
                })
                openModal();
                setOnConfirm(() => closeModal);
            }

        } catch (err) {
            setShowCancelButton(false);
            setModalType({
                icon: 'error',
                title: 'Seat Retrieval',
                text: err.response.data.message
            })
            openModal();
            setOnConfirm(() => closeModal);
        } finally {
            setLoading(false)
        }
    };

    const handleConfirmation = (purpose) => {
        setModalType({
            icon: "warning",
            title: "Seat Manipulation Confirmation",
            text: `Are you sure to ${purpose} to Seat in  College Code : ${collegeCode} | Branch : ${branch} | Community : ${community}`,
        });
        setShowCancelButton(true);
        openModal();
        const handleIncrement = () => incrementSeat();
        const handleDecrement = () => decrementSeat();
        setOnConfirm(() => purpose === "Increment" ? handleIncrement : handleDecrement);
        setOnCancel(() => closeModal);
    }


    useEffect(() => {
        // console.log('hi')
        if (!collegeCode || !branch) return;

        const fetchCollegeData = async () => {
            setShowCancelButton(false);
            try {
                const response = await axios.post(`${serverUrl}/api/admin/seat-manipulation/seats`, { code: collegeCode, branch });
                if (response.status == 200) {
                    setCollege(response.data.seatValues[0] || {});
                    // setModalType({
                    //     icon: 'success',
                    //     title: 'Seat Retrieval',
                    //     text: response.data.message
                    // })
                    // openModal();
                    // setOnConfirm(() => closeModal);
                }

            } catch (err) {
                // console.error('Failed to fetch college data:', err);
                setModalType({
                    icon: 'error',
                    title: 'Seat Retrieval',
                    text: err.response.data.message
                })
                openModal();
                setOnConfirm(() => closeModal);
            }
        };

        fetchCollegeData();
    }, [refreshKey]);

    if (loading) {
        return <Loader />
    }

    return (
        <div className='chart-container' style={{overflow:'hidden',margin:'0'}}>
            <div className="seat-man-container">
                <div className="seat-man-form-section">
                    <h1>SEAT MANIPULATION</h1>
                    <div className='seat-man-input-continaer'>
                        <div className="seat-man-input-group">
                            <label>COLLEGE CODE</label>
                            <section>
                                <input
                                    type="text"
                                    placeholder="Enter college code"
                                    value={collegeCode}
                                    onChange={handleCollegeCodeChange}
                                />
                                <button onClick={handleRequest}>Fetch Branch</button>
                            </section>
                        </div>

                        <div className="seat-man-input-group">
                            <label>BRANCH</label>
                            <select value={branch} onChange={handleBranchChange}>
                                <option value="">-- Select Branch --</option>
                                {branches.map((name) => (
                                    <option key={name.BRANCH} value={name.BRANCH}>
                                        {name.BRANCH}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <table className="seat-man-data-table">
                    <thead>
                        <tr>
                            <th>College Code</th>
                            <th>College Name</th>
                            <th>Branch Name</th>
                            <th>OC</th>
                            <th>BCM</th>
                            <th>BC</th>
                            <th>MBC</th>
                            <th>SCA</th>
                            <th>SC</th>
                            <th>ST</th>
                            <th>COUNTER</th>
                            <th>TOTAL</th>
                            <th>ALLOT ADD</th>
                        </tr>
                    </thead>
                    <tbody>
                        {college &&
                            <tr>
                                <td>{college.COLL_CODE}</td>
                                <td><input disabled value={college.INSTITUTION || ''} /></td>
                                <td>{branch}</td>
                                <td>{college.OC}</td>
                                <td>{college.BCM}</td>
                                <td>{college.BC}</td>
                                <td>{college.MBC}</td>
                                <td>{college.SCA}</td>
                                <td>{college.SC}</td>
                                <td>{college.ST}</td>
                                <td>{college.COUNTER}</td>
                                <td>{college.TOTAL}</td>
                                <td>{college.ALLT_ADD}</td>
                            </tr>
                        }
                    </tbody>
                </table>

                <div className="seat-man-form-section">
                    <div className="seat-man-input-group">
                        <label>COMMUNITY</label>
                        <select value={community} onChange={(e) => setCommunity(e.target.value)}>
                            <option value="" disabled>-- Select --</option>
                            <option value="ST">ST</option>
                            <option value="SCA">SCA</option>
                            <option value="SC">SC</option>
                            <option value="MBC">MBC</option>
                            <option value="BC">BC</option>
                            <option value="BCM">BCM</option>
                            <option value="OC">OC</option>
                        </select>
                    </div>

                    <div className="seat-man-button-group">
                        <button onClick={() => handleConfirmation('Increment')} disabled={!community}>Increment</button>
                        <button onClick={() => handleConfirmation('Decrement')} disabled={!community}>Decrement</button>
                    </div>
                </div>
                <div
                    style={{
                        position: "relative",
                        alignSelf: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <PopModal
                        isOpen={isModalOpen}
                        type={modalType}
                        confirmButtonText="OK"
                        onConfirm={onConfirm}
                        showCancelButton={showCancelButton}
                        cancelButtonText="Cancel"
                        onCancel={onCancel}
                    />
                </div>
            </div>
        </div>

    );
}

export default SeatManipulation;